import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import { createBrowserHistory } from 'history';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { addLocaleData, IntlProvider } from 'react-intl';
import pl from 'react-intl/locale-data/pl';

import asyncMiddleware from './middleware/middleware';
import reducers from './reducers/index';
import Full from './containers/Full/';
import LoginPage from './views/LoginPage/LoginPage';
import AuthProvider from './components/AuthProvider/AuthProvider';

const messages = require('./assets/i18n/pl.json');

const history = createBrowserHistory();

const storeWithMiddleWare = applyMiddleware(asyncMiddleware)(createStore);
const store = storeWithMiddleWare(reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

addLocaleData([...pl]);

ReactDOM.render((
    <IntlProvider locale='pl' messages={messages}>
        <Provider store={store}>
            <Router history={history}>
                <Switch>
                    <Route path="/admin" name="Admin" component={AuthProvider(Full)}/>
                    <Route exact path='/login' name='Login' component={LoginPage} />
                    <Redirect from="/" to="/admin"/>
                </Switch>
            </Router>
        </Provider>
    </IntlProvider>
), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js